module.exports = __webpack_public_path__ + "img/man_1_iocn.3ddca436.png";